
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/nigmabot-ai",
      function () {
        return require("private-next-pages/products/nigmabot-ai.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/nigmabot-ai"])
      });
    }
  